<template>
  <router-view />
</template>

<script>
export default {
  name: 'LayoutChildren',
};
</script>
